export default __webpack_public_path__ + "static/media/icon-peace.0d7aa2e7.png";